module.exports = __webpack_public_path__ + "img/icon_map_7_on_100.2e906304.png";